<template>
    <div class="panel-body">
        <HeaderGeneral :vista="vista" :ruta="proveniente" :carpeta="carpeta" />
         <TableGeneral :optionst="options" :optionss="optionss" :fields="fields" :requiereListas="requiereListas" 
         :requiereDescarga="requiereDescarga" :condicionFiltrao="condicionFiltrao" :cliente="cliente" :editar="editable"
         :opcionRechazar="opcionRechazar" :opcionGestionar="opcionGestionar"  :requiereGestionar="requiereGestionar"
         :titulomodal="titulomodal" :botonmodal="botonmodal" :requiereBotongestionar="requiereBotongestionar"
         :condicionales="condicionales" :carpeta="carpeta"  :typeOrder="typeOrder"
         :requiereIntentoEntrega="false" :nombreEntidadCustom="nombreEntidad"></TableGeneral>
     </div>
    
 </template>
 
 <script>
 import { RepositoryFactory } from "../../repositories/RepositoryFactory";
 import Vue from 'vue'
 import VueFormGenerator from 'vue-form-generator'
 import 'vue-form-generator/dist/vfg.css'
 import TableGeneral from "../../components/Table.vue";
 import HeaderGeneral from "../../components/HeaderGeneral.vue";
 import "vue-form-generator/dist/vfg-core.css";
 
 
 Vue.use(VueFormGenerator)
 
 const config = RepositoryFactory.get("config");
 const clientes = RepositoryFactory.get("clientes");
 export default {
     components: {
         "vue-form-generator": VueFormGenerator.component,
         TableGeneral,
         HeaderGeneral
     },
     data() {
         return {
            nombreEntidad: "entidad_solicitud_log",
            typeOrder: "desc",
             vista:"Solicitudes Devueltas",
             proveniente:" - Solicitudes Devueltas",
             carpeta:"Proveedores",
             requiereListas:true,
             requiereDescarga:true,
             condicionFiltrao:"en solicitud",
             editable:1,
             cliente:1,
             requiereGestionar:false,
             opcionRechazar:false,
             opcionGestionar:false,
             titulomodal:"Detalles de Solicitud Devuelta",
             botonmodal:"Aceptar",
             requiereBotongestionar:"si",
             options: [
                { value: null, text: 'Seleccionar' }, 
                { value: 'id', text: 'Número de solicitud' }, 
                { value: 'documento', text: 'Documento' }, 
                { value: 'nombre_completo', text: 'Paciente' }, 
                { value: 'departamento', text: 'Departamento' }
             ],
             
             departamentos: [{ value: null, text: 'Seleccionar' },],
            optionsclientes: [
                { value: null, text: 'Seleccionar' },
                { value: 1, text: 'cliente1' },
                { value: 2, text: 'clientes2' }
            ],
            optionsdos: [
                { value: null, text: 'Seleccionar' },
                { value: 'observaciones_devolucion_proveedor', text: 'Observación Devolución' },
                { value: 'motivo_devolucion_proveedor', text: 'Motivo Devolución' }
            ],
            optionss: [
                { value: null, text: 'Seleccionar' },
                { value: '4', text: 'Devuelto' }
            ],
            optionm:[
                { value: null, text: 'Seleccionar' },
                { value: '4', text: 'Devuelto' }
             ],
            endDate: "",
            fields: [
                { key: 'N°Solicitud', sortable: true },
                { key: 'Solicitante', sortable: true }, 
                { key: 'F.Solicitud', sortable: true }, 
                { key: 'Asignó', sortable: true }, 
                { key: 'F.Asignación', sortable: true }, 
                { key: 'T.Documento', sortable: true },
                { key: 'Documento', sortable: true },
                { key: 'Paciente', sortable: true },
                { key: 'Ciudad', sortable: true },
                { key: 'Departamento', sortable: true },
                { key: 'Estado', sortable: true },
                { key: 'Motivo Devolución', sortable: true },
                { key: 'Observación Devolución', sortable: true },
                'Acciones'
            ],
            fieldsdos: ['Fecha', 'Estado', 'Observación'],
            condicionales: null
         }
 
     },
     computed: {
       
     },
     async created() {
         // Obtener id_proveedor del usuario autenticado
         const datosUser = localStorage.getItem('user');
         let datoUserJSON = JSON.parse(datosUser);
         let dato_proveedor = datoUserJSON.id_proveedor;
         
         // Filtrar registros del log con estado 4 (Devuelto) y por el proveedor actual
         // Usa datos_anteriores.id_proveedor porque al devolver una solicitud 
         // el id_proveedor del JSONB principal se resetea a 0
         this.condicionales = {
             "AND": [
                 {
                     "estado": {
                         "equals": "4"
                     }
                 },
                 {
                     "datos_anteriores.id_proveedor": {
                         "equals": dato_proveedor.toString()
                     }
                 }
             ]
         };
     },
     methods: {
      
     }
 };
 </script>
 <style>
 </style>
